import React from 'react';
import OfferingsList from 'components/Dashboard/OfferingsList';
import './styles.scss';

const MainSection = () => (
  <div className="dashboard-mainsection-wrapper">
    <OfferingsList />
  </div>
);

export default MainSection;
